import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2c2450d8")

_pushScopeId("data-v-2c2450d8")
const _hoisted_1 = { class: "full-width table-responsive" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { key: 0 }
_popScopeId()


    import {isValueOther} from '@/services/reporting'
    
export default _defineComponent({
  props: {
        rows: {type: Array<any>},
        labels: {type: Array<any>},
    },
  emits: ['next'],
  setup(__props, { emit: emits }) {

const props = __props


    
    function isComplex(cell) {
        console.log('reporting:table:cell', cell)
        return typeof cell === 'object'
    }
    function click(event, value) {
        if (isValueOther(value)) {
            event.preventDefault();
            emits('next')
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("table", _hoisted_2, [
      _createVNode("thead", null, [
        _createVNode("tr", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(__props.labels, (label) => {
            return (_openBlock(), _createBlock("th", { key: label }, _toDisplayString(label), 1))
          }), 128))
        ])
      ]),
      _createVNode("tbody", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(__props.rows, (row) => {
          return (_openBlock(), _createBlock("tr", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(row, (value) => {
              return (_openBlock(), _createBlock("td", null, [
                (isComplex(value))
                  ? (_openBlock(), _createBlock("span", _hoisted_4, [
                      (value.link)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            href: value.link,
                            target: "_blank",
                            onClick: e => click(e, value.label)
                          }, _toDisplayString(value.label), 9, ["href", "onClick"]))
                        : (_openBlock(), _createBlock("span", {
                            key: 1,
                            onClick: e => click(e, value.label),
                            class: _unref(isValueOther)(value.label) ? 'btn btn-link p-0' :'' 
                          }, _toDisplayString(value.label), 11, ["onClick"]))
                    ]))
                  : (_openBlock(), _createBlock("span", {
                      key: 1,
                      onClick: e => click(e, value),
                      class: _unref(isValueOther)(value) ? 'btn btn-link p-0' :'' 
                    }, _toDisplayString(value), 11, ["onClick"]))
              ]))
            }), 256))
          ]))
        }), 256))
      ])
    ])
  ]))
}
}

})